import { render, staticRenderFns } from "./OperaGoodsBrandWindow.vue?vue&type=template&id=2c2b5ed8&scoped=true&"
import script from "./OperaGoodsBrandWindow.vue?vue&type=script&lang=js&"
export * from "./OperaGoodsBrandWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaGoodsBrandWindow.vue?vue&type=style&index=0&id=2c2b5ed8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2b5ed8",
  null
  
)

export default component.exports